import { GlobalAlertReducerState } from './types';

export const defaultState: GlobalAlertReducerState = {
  isOpened: false,
  message: ''
};
